import React, { Component, useMemo } from "react";
import { Helmet } from "_c/Helmet";
import { generateUrl } from "@/utils/cloudinary";
import { SITE_URL } from "@/misc/constants";
import { LinkGenerator } from "@/utils/LinkGenerator";
import moment from "moment";
import { DEFAULT_SALOON_LOGO } from "@/misc/constants";
import qs from "query-string";
import isempty from "lodash/isEmpty";
import { DEFAULT_CURRENCY } from "@/config";

const ns = "saloon_profile:seo";
const SaloonPageSEO = ({ specs, meta, avatar, saloonId, t }) => {
  // TODO:: render schema for bots only
  const pageLink = SITE_URL + LinkGenerator.saloonProfile(meta.saloonId);
  const transAddress = meta.address
    ? t(`${ns}.address`, { address: meta.address })
    : "";
  const avatarLink = avatar
    ? generateUrl(avatar)
    : SITE_URL + DEFAULT_SALOON_LOGO;
  const canonical = qs.stringifyUrl({
    url: `${SITE_URL}/salon`,
    query: {
      id: saloonId,
    },
  });
  const uniqSpecs = useMemo(() => {
    if (isempty(meta.uniqSpecs) || isempty(specs)) return "";
    return meta.uniqSpecs
      .reduce((acc, specId) => {
        const title = specs[specId]?.title;
        if (title) {
          acc.push(title);
        }
        return acc;
      }, [])
      .join(", ");
  }, [meta, specs]);
  const i18nTitleAndDescVars = {
    type: meta.orgType || t(`${ns}.default_org_type`),
    name: meta.nameWithoutOrgType || "",
    address: transAddress,
    specs: uniqSpecs,
    num: meta.pricingStartsFrom?.amount || 0,
    currency: meta.pricingStartsFrom?.currency || DEFAULT_CURRENCY,
  };
  return (
    <>
      <Helmet
        link={[{ rel: "canonical", href: canonical }]}
        title={t(`${ns}.title`, i18nTitleAndDescVars)}
        meta={[
          {
            property: "og:image",
            content: avatarLink,
          },
          {
            name: "description",
            content: t(`${ns}.desc`, i18nTitleAndDescVars),
          },
        ]}
      />
      <BotsOnly
        pageLink={pageLink}
        avatarLink={avatarLink}
        t={t}
        meta={meta}
        avatar={avatar}
      />
    </>
  );
};
class BotsOnly extends Component {
  shouldComponentUpdate() {
    return false;
  }
  render() {
    const { meta, pageLink, avatarLink } = this.props;
    return (
      <Helmet>
        {meta.services.map((service) => (
          <script key={service.name} type="application/ld+json">
            {JSON.stringify(service)}
          </script>
        ))}
        <script type="application/ld+json">{`
{
	"@context": "https://schema.org/",
	"@type": "BeautySalon",
	${
    meta.coords
      ? `
	"geo": {
		"@type": "GeoCoordinates",
    "latitude": ${meta.coords[1]},
    "longitude": ${meta.coords[0]}
  },
	`
      : ""
  }
  "name": "${meta.name}",
  "legalName": "${meta.name}",
	"@id": "${meta.saloonId}",
	"url": "${pageLink}",
	"image": "${avatarLink}",
	"address": {
		"@type": "PostalAddress",
		"streetAddress": "${meta.address}"
	},
	"aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": ${meta.rate},
    "ratingCount": ${meta.reviewsCount}
	},
	"review": [
		${meta.reviews.map(
      (review) => `
		{
			"@type": "Review",
			"author": {
				"@type": "Person",
				"name": "${[review.client.first_name, review.client.last_name]
          .filter(Boolean)
          .join(" ")}"
			},
			"reviewRating": {
				"@type": "Rating",
				"ratingValue": "${review.rate}"
			},
			"datePublished": "${moment(review.created_at).format("YYYY-MM-DD")}",
			"reviewBody": "${review.text}"

		}
		`,
    )}
	],
	"acceptsReservations": "True",
	"openingHoursSpecification": ${JSON.stringify(meta.workingHours)}
}
`}</script>
      </Helmet>
    );
  }
}

export default SaloonPageSEO;
